/* eslint-disable */
import { ProductChangelogItemCustomerDetailDto } from '../dto/product-changelog-item-customer-detail-dto';

export interface ProductChangelogCustomerDetailDto {
  releaseDate: Date;
  version?: string | null;
  items: ProductChangelogItemCustomerDetailDto[];
}

export const fixProductChangelogCustomerDetailDtoFromJson = (dto?: ProductChangelogCustomerDetailDto | null): void => {
  if (!dto) {
    return;
  }
  dto.releaseDate = dto.releaseDate && new Date(dto.releaseDate);
};

export const fixProductChangelogCustomerDetailDtoToJson = (dto?: ProductChangelogCustomerDetailDto | null): void => {
  if (!dto) {
    return;
  }
};
